import * as ko from "knockout";
import { ContractViewModel } from "../ViewModels/ContractViewModel";
import { PdfApi } from "../Apis/PdfApi";
import { EReportType } from "../Models/Pdf/ReportType";
import { ContractApi } from "../Apis/ContractApi";

export class Contracts {
    pdfApi: PdfApi;
    contractApi: ContractApi;
    contractViewModel: ContractViewModel;
    $contractTables: JQuery;
    $downloadId: JQuery;
    constructor() {
        this.pdfApi = PdfApi.getInstance();
        this.contractApi = ContractApi.getInstance();
        this.$contractTables = $("#contracts-table");
        this.contractViewModel = new ContractViewModel();
        if (this.$contractTables[0]) {
            ko.applyBindings(this.contractViewModel,this.$contractTables[0]);
        }
    }

    init(): void {
        this.contractApi.getContracts().then((res) => {
            this.contractViewModel.completelist(res);
            this.contractViewModel.loading(false);
            this.attachPdfDownloadJquery();
        });
    }

    private attachPdfDownloadJquery(): void { 
        const self = this;
        self.$contractTables.on('click', '[id *= download]', function (e: any) {
            const id = $(this).attr('id');
            const fileName = $(this).attr('filename');
            const entryNo = Number.parseInt(id.split('download')[1]);
            const company = $(this).attr('company');
            self.pdfApi.downloadFile(entryNo, fileName,company);
        });
    }
}